import { ComponentTagVO } from '@repo/types'
import { fetcher } from '../utils'

export default async (id: string): Promise<ComponentTagVO> => fetcher(`/api/tag/${id}`, 'GET', undefined)
